import { useSelector } from "react-redux"
import { usePathname } from "next/navigation"
import CompetitionSignUp from "./CompetitionSignUp"
import classNames from "classnames"
import Link from "next/link"

export default function ShareData({children, popup, setPopup}) {

    const pathname = usePathname()
    const global = useSelector((state) => state.global)
    const compete = useSelector((state) => state.compete)
    const registrationStatus = compete.stages?.find(stage => stage.shortcut === "registration")?.current_status
    const pageNav = [
        {
            title: `${global.currentCompeteYear} 報名`,
            url: "/user/compete",
            type: "submitted"
        },
        {
            title: "草稿",
            url: "/user/compete/drafts",
            type: "draft"
        },
        {
            title: "歷屆報名紀錄",
            url: "/user/compete/history",
            type: "history"
        }
    ]

    return (
        <>
            <div className="user-page-title">
                <div className="content">
                    <h2 className="sub-title sm:mb-3">{global.currentCompeteYear} 放視大賞</h2>
                    <h1 className="title">參賽報名</h1>
                </div>
            </div>

            <main id="main" className="user-compete pb-16 md:pb-24 lg:pb-40">
                <div className="tab-nav flex items-center">
                    <Link
                        href={pageNav[0].url}
                        className={classNames('font-semibold mb-[-1px] pt-4 pb-3.5', {
                            'selected': pathname === pageNav[0].url
                        })}
                    >{pageNav[0].title} ({compete.submitted?.count || 0})</Link>

                    {(registrationStatus && registrationStatus !== "not-started") &&
                        pageNav.filter(d => d.type !== "submitted").map((data) => (
                            <Link
                                key={data.title}
                                href={data.url}
                                className={classNames('font-semibold mb-[-1px] pt-4 pb-3.5 ml-10', {
                                    'selected': pathname === data.url,
                                    'hidden': data.type === 'history' && (compete[data.type]?.count || 0) === 0
                                })}
                            >{data.title} ({compete[data.type]?.count || 0})</Link>
                        )
                    )}
                </div>

                {children}

                { popup === 'sign-up' &&
                    <CompetitionSignUp options={compete.categories} setPopup={setPopup} />
                }
            </main>
        </>
    )
}
